module.exports = __webpack_public_path__ + "static/media/share-button.fa0facbb.svg";